import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: { language: "", question_id: 0, id: 1 },
  user_code: "",
  stdin: "",
  stdout: "",
  expected_output: "",
  passed_test_cases: "",
  last_code_run_time: null,
  code_modified_since_run: false,
};

export const answerCodeSlice = createSlice({
  name: "answerCode",
  initialState,
  reducers: {
    cleanAnswerCode: () => initialState,
    updateLanguage: (state, action) => {
      state.language = action.payload;
    },
    updateCode: (state, action) => {
      state.user_code = action.payload;
      state.code_modified_since_run = true;
    },
    updateSTDIN: (state, action) => {
      state.stdin = action.payload;
    },
    updateOUTPut: (state, action) => {
      state.stdout = action.payload;
    },
    updateExpectedOutput: (state, action) => {
      state.expected_output = action.payload;
    },
    updatePassedTestCases: (state, action) => {
      state.passed_test_cases = action.payload;
    },
    resetPassedTestCases: (state) => {
      state.passed_test_cases = "";
    },
    updateCodeRunTime: (state) => {
      state.last_code_run_time = Date.now();
      state.code_modified_since_run = false;
    },
  },
});

export const {
  updateLanguage,
  updateCode,
  updateSTDIN,
  updateOUTPut,
  cleanAnswerCode,
  updateExpectedOutput,
  updatePassedTestCases,
  resetPassedTestCases,
  updateCodeRunTime,
} = answerCodeSlice.actions;
export default answerCodeSlice.reducer;
